import request from '@/utils/request'

export function exchange(params) {
    return request({
        url: '/market/exchange',
        method: 'get',
        params
    })
}

export function contract(params) {
    return request({
        url: '/market/contract',
        method: 'get',
        params
    })
}

export function second(params) {
    return request({
        url: '/market/second',
        method: 'get',
        params
    })
}

export function stock(params) {
    return request({
        url: '/market/stock',
        method: 'get',
        params
    })
}


export function forex(params) {
    return request({
        url: '/market/forex',
        method: 'get',
        params
    })
}


export function fund(params) {
    return request({
        url: '/market/fund',
        method: 'get',
        params
    })
}


export function getKline(params) {
    return request({
        url: '/market/kline',
        method: 'get',
        params
    })
}


export function search(params) {
    return request({
        url: '/market/search',
        method: 'get',
        params
    })
}


export function choose(params) {
    return request({
        url: '/market/choose',
        method: 'get',
        params
    })
}
